import type { ConfiguratorMutationResult } from "~/features/configurator/Linear/redux/configuratorMutationCoordinator";

export interface PendingSubmissionGuard {
  pending: boolean;
}

export function tryBeginPendingSubmission(guard: PendingSubmissionGuard): boolean {
  if (guard.pending) {
    return false;
  }

  guard.pending = true;
  return true;
}

export async function runAfterPendingConfiguratorUpdate<T>(
  runSubmission: (submit: () => Promise<T>) => Promise<ConfiguratorMutationResult<T>>,
  submit: () => Promise<T>,
): Promise<T> {
  const result = await runSubmission(submit);
  if (result.status === "success") {
    return result.value;
  }
  if (result.status === "failed") {
    throw result.error;
  }
  if (result.status === "blocked") {
    throw new Error("Pending configurator update failed");
  }
  throw new Error("Unknown configurator submission result");
}
